import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { EmployeeOrgUnit } from '../data/employee-org-unit';
import { environment } from '../../environments/environment';
import { BodyOrgUnitPath } from '../body/body-org-unit-path';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { OrgUnit } from '../data/org-unit';
import { CostCentre } from '../data/cost-centre';

@Injectable({
  providedIn: 'root'
})
export class EmployeeOrgUnitService {
  private http = inject(HttpClient);

  controllerURL = '/api/employee-org-units';

  getOrgUnits(): Observable<EmployeeOrgUnit[]> {
    return this.http.get<EmployeeOrgUnit[]>(environment.zyrusApiUrl + this.controllerURL);
  }

  chooseOrgUnit(body: BodyOrgUnitPath): Observable<void> {
    const headers = new HttpHeaders()
      .append('Content-Type', 'application/json');

    return this.http.post<void>(environment.zyrusApiUrl + this.controllerURL, body, { headers });
  }

  deleteOrgUnit(id: string): Observable<void> {
    return this.http.delete<void>(environment.zyrusApiUrl + this.controllerURL + '/' + id);
  }

  getAvailableOrgUnits(): Observable<OrgUnit[]> {
    return this.http.get<OrgUnit[]>(environment.zyrusApiUrl + this.controllerURL + '/available-org-units');
  }

  getAvailableCostCentres(): Observable<CostCentre[]> {
    return this.http.get<CostCentre[]>(environment.zyrusApiUrl + this.controllerURL + '/available-cost-centres');
  }
}
